import React, { PropTypes } from 'react';
import { Card } from '../../components';

const List = ({ items }) => (
  <div className="row">
    <div className="col-xs-12">
      <div className="resources flex-wrapper webinar">
        {items && items.length
          ? items.map(({ label, className, title, imageUrl, url }, index) => (
              <Card
                key={index}
                label={label}
                className={label}
                title={title}
                imageUrl={imageUrl}
                url={url}
              />
            ))
          : <h3>There isn't any resource yet.</h3>}
      </div>
    </div>
  </div>
);

List.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
      title: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired
    })
  ).isRequired
};

export default List;



// WEBPACK FOOTER //
// ./src/pages/resources/components/List/List.js